import React, { useState } from 'react';

import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';

import LoadingScreen from 'src/components/LoadingScreen';

import { useData } from 'src/contexts/data';
import { ModelOfOrderService } from 'src/database';
import { useOrderServiceListController } from 'src/controllers/OrderService/ListOrderServiceController';
import OrderServiceCard from 'src/components/Cards/ServiceOrderCard/OrderServiceCard';

//import './styles.scss';

const OrderServiceList: React.FC = () => {
	const { getOrderServiceListController, handleOrderServiceListController } = useOrderServiceListController();
	const [globalFilter, setGlobalFilter] = useState<string>('');
	const { handleSelectedOrderService } = useData();

	if (getOrderServiceListController.loading) {
		return <LoadingScreen />;
	}

	const handleFilter = (OrderServiceList: ModelOfOrderService[]) => {
		const OrderService = OrderServiceList.filter((orderService) =>
			orderService.DESCRICAO_DEMANDA?.toUpperCase().includes(globalFilter?.toUpperCase())
		);
		return OrderService;
	};

	return (
		<div className='p-card p-p-4 datatable-container'>
			<Toast ref={getOrderServiceListController.toast} />
			<div className='service-header p-grid'>
				<h5 className='p-m-0'>Ordem de serviços</h5>
				<span className='p-input-icon-left p-search-bar'>
					<i className='pi pi-search' />
					<InputText
						type='search'
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalFilter(e.target.value)}
						placeholder='Filtrar por Descricao'
					/>
				</span>
			</div>

			{getOrderServiceListController.orderServiceData.length ? (
				handleFilter(getOrderServiceListController.orderServiceData).map((OrderService) => {
					let newOrder = handleOrderServiceListController.handleClickOrderService(OrderService);

					return (
						<OrderServiceCard
							key={OrderService.ID}
							orderService={OrderService}
							handleClick={() => {
								handleSelectedOrderService(newOrder);
							}}
							handlePrint={() =>{
								console.log(" -----> Passei aqui")
								//handleSelectedOrderService(newOrder);
								handleOrderServiceListController.printClickOrderService(newOrder)
							}}
						/>
					);
				})
			) : (
				<h5>Nenhum resultado encontrado!</h5>
			)}
		</div>
	);
};

export default OrderServiceList;
